window.PersonalDetails = (function () {
    const SNACKBAR = true;
    let self = {
        func: {
            init: function() {

                self.func.checkSessionStorageForMessage();
            },
            checkSessionStorageForMessage: function() {

                const message = sessionStorage.getItem('snackbarMessage');
                if (message) {

                    window.snackBar(message, SNACKBAR, 'Action');
                    sessionStorage.removeItem('snackbarMessage');
                }
            }
        }
    };

    return {
        Init: self.func.init
    };
})();
$(document).ready(function () {
       if ('personalDetails' === $('#personal-details').data('feature')) {
        window.PersonalDetails.Init();
    }
});
